/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconMapDiscount = createReactComponent("outline", "map-discount", "IconMapDiscount", [["path", { "d": "M13 19l-4 -2l-6 3v-13l6 -3l6 3l6 -3v8.5", "key": "svg-0" }], ["path", { "d": "M9 4v13", "key": "svg-1" }], ["path", { "d": "M15 7v5.5", "key": "svg-2" }], ["path", { "d": "M16 21l5 -5", "key": "svg-3" }], ["path", { "d": "M21 21v.01", "key": "svg-4" }], ["path", { "d": "M16 16v.01", "key": "svg-5" }]]);

export { IconMapDiscount as default };
//# sourceMappingURL=IconMapDiscount.mjs.map
